var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 769,
    height: 769,
    viewBox: "0 0 769 769",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384.5 768.942C172.498 768.942 0 596.502 0 384.5C0 172.498 172.498 0 384.5 0C596.502 0 769 172.498 769 384.5C769 596.502 596.502 769 384.5 769M384.5 25.4866C186.516 25.4287 25.4287 186.516 25.4287 384.5C25.4287 582.484 186.516 743.571 384.5 743.571C582.484 743.571 743.571 582.484 743.571 384.5C743.571 186.516 582.484 25.4287 384.5 25.4287",
    fill: "#2A2C31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.777 198.981L226.077 293.166H105.19C103.799 293.108 101.83 292.934 100.15 292.413C92.3305 289.864 87.6387 281.813 90.5349 274.109C100.845 247.058 114.863 221.919 131.777 198.981Z",
    fill: "#2A2C31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M363.001 650.647C363.001 676.887 338.673 696.581 313.128 690.615C174.168 658.235 70.3105 533.64 70.3105 384.949C70.3105 368.325 71.9903 352.106 74.4811 336.119H269.048L362.943 430.014V650.589L363.001 650.647Z",
    fill: "#2A2C31"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M362.959 369.331L187.912 194.285C187.912 194.285 175.285 182.99 168.16 173.143C160.456 162.427 173.142 153.043 173.142 153.043C224.289 105.661 289.164 76.9886 363.017 71.9492V369.331H362.959Z",
    fill: "#2A2C31"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M405.934 71.9492C439.993 74.2662 472.546 82.028 502.783 94.3658C507.822 97.0303 510.487 103.17 504.462 110.295C503.652 111.222 405.934 207.665 405.934 207.665V71.9492Z",
    fill: "#2A2C31"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M405.934 267.753L555.088 121.552C569.164 130.704 582.486 140.841 594.882 152.02C594.882 152.02 606.872 161.462 594.998 173.568L405.934 362.632V267.811V267.753Z",
    fill: "#2A2C31"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M455.343 690.795C430.03 696.645 405.934 677.124 405.934 651.174V590.586L557.119 438.924C564.514 431.505 564.51 419.5 557.109 412.086L553.81 408.782C546.392 401.351 534.353 401.346 526.929 408.77L405.934 529.766V423.765C405.934 423.012 406.223 422.316 406.745 421.795L634.154 195.138C674.412 247.965 698.624 313.651 698.624 385.013C698.624 533.878 594.534 658.589 455.343 690.795Z",
    fill: "#2A2C31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerLogo);
export default __webpack_public_path__ + "static/media/bannerLogo.ccaf55c62878dc0d50010856fc5d2a6a.svg";
export { ForwardRef as ReactComponent };